import React, { Component, useLayoutEffect } from "react";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";
import queryString from "query-string";
import Footer from "./Footer/Footer";
import PrimaryAppBarMobile from "../components/PrimaryAppBarMobile";
import { withStyles } from "@material-ui/core/styles";

import mobileMainLogo from "../images/mobileMainLogo.png";
import desktopMainLogo from "../images/desktopMainLogo.png";
import mobileMainLogoEng from "../images/mobileMainLogoEng.jpeg";
import desktopMainLogoEng from "../images/desktopMainLogoEng.jpeg";

import ArbitrationProcedure from "../components/ArbitrationProcedure";
import ArbitratorFeeCalculator from "../components/ArbitrationFeeCalculator";
import OnlineArbitrationClause from "../components/OnlineArbitrationClause";
import ArbitrationAgreement from "../components/ArbitrationAgreement";
import ArbitrationListForView from "../components/ArbitrationListForView";
import GeneralDialog from "../components/GeneralDialog";

import icon4 from "../images/icon4.png";
import icon5 from "../images/icon5.png";
import icon6 from "../images/icon6.png";
import icon7 from "../images/icon7.png";
import icon9 from "../images/icon9.png";
import icon10 from "../images/icon10.png";
import sloganEng from "../../src/images/sloganEng.png";
import sloganChi from "../../src/images/sloganChi.png";
import mainTimelineChi from "../images/mainTimelineChi.png";
import mainTimelineEng from "../images/mainHkas.png";
import logo from "../images/logo.png";
import withSizes from "react-sizes";
import MainPanel from "../../src/containers/NavTabs/MainPanel";
import LoginForm from "../containers/Auth/LoginForm";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import MainChatbot from "./Onboarding/MainChatbot";
import { Route, Link, Redirect, Switch, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import * as actions from "../store/actions/index";
import Button from "@material-ui/core/Button";

const arbitrationProcedures = <ArbitrationProcedure />;
const arbitratorFeeCalculator = <ArbitratorFeeCalculator />;
const arbitrationListForView = <ArbitrationListForView />;

var innerWidth = window.innerWidth;

const styles = (theme) => ({
  root: {
    // flexGrow: 1,
  },
  container: {
    height: "auto",
  },
  picFont: {
    textAlign: "center",
    // marginLeft: "auto",
    // marginRight: "auto",
    color: "black",
    textTransform: "none",
    fontWeight: "bolder",
  },
  title: {
    fontSize: "x-large",
    color: "#6C0E21",
    fontWeight: "bolder",
    textAlign: "center",
  },
  lightTitle: {
    fontSize: "xx-large",
    color: "#950026",
    marginTop: "-20px",
    fontWeight: "normal",
    textAlign: "center",
  },
  mainText: {
    fontSize: "large",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: "bold",
    textAlign: "center",
    color: "black",
  },
  control: {
    padding: theme.spacing.unit * 1,
  },
  paper: {
    padding: theme.spacing.unit * 1,
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  mainIcon: {
    // paddingLeft: "100px",
    // paddingRight: "100px",
    textAlign: "center",
  },
  icons: {
    width: "140px",
  },
  bInput: {
    background: "rgba(255, 255, 255)",
    outline: "0",
    color: "#6C0E21",
    textTransform: "none",
    wordWrap: "break-word",
    wordBreak: "break-word",
    border: "2px solid #6C0E21",
    paddingTop: "15px",
    paddingBottom: "15px",
    borderRadius: "25px",
    fontWeight: "bold",
    marginLeft: "3px",
    marginRight: "3px",
    boxSizing: "border-box",
    fontSize: "16px",
    "&:hover": {
      color: "white",
    },
  },

  lastB: {
    background: "#6C0E21",
    outline: "0",
    color: "white",
    wordWrap: "break-word",
    wordBreak: "break-all",
    border: "2px solid #6C0E21",
    paddingTop: "0px",
    paddingBottom: "0px",
    borderTopLeftRadius: "30px",
    borderBottomLeftRadius: "30px",
    borderTopRightRadius: "30px",
    borderBottomRightRadius: "30px",
    height: "30px",
    width: "170px",
    boxSizing: "border-box",
    // fontSize: '14px',
  },
  mainB: {
    padding: "0px",
    textAlign: "center",
  },
  mainC: {
    padding: "10px",
    textAlign: "center",
  },
  mainD: {
    padding: "10px",
    textAlign: "center",
    fontSize: "25px",
    fontWeight: "900",
  },
  mainDd: {
    padding: "20px",
    textAlign: "center",
    // marginBottom:'60px'
  },
  textRed: {
    color: "#6C0E21",
    fontWeight: "900",
  },
});

class LandingPage extends Component {
  constructor(props) {
    super(props);
    this.showDialog = this.showDialog.bind(this);
  }

  state = {
    windowHeight: undefined,
    windowWidth: undefined,
    typeDialog: false,
    calculator: false,
    showOnlineArbitrationClauses: false,
  };

  showDialog(v, e) {
    this.setState({
      [v]: e,
    });
  }

  checkLanguage = function () {
    try {
      // console.log('this caseData: '+JSON.stringify(this.props.caseData))
      var lang = localStorage.getItem("language");
      if (lang == undefined) {
        localStorage.setItem("language", "cn");
        setTimeout(() => {
          window.location.reload();
        }, 100);
      }
    } catch (err) {
      setTimeout(() => {
        this.checkLanguage();
      }, 100);
    }
  };

  handleResize = () => {
    this.setState({
      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,
    });
    this.innerWidth = window.innerWidth;
    console.log(
      "Window Size: window.innerHeight: " +
        window.innerHeight +
        " window.innerWidth: " +
        window.innerWidth +
        " div 4: " +
        window.innerWidth / 4
    );
  };

  componentDidMount() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
    this.checkLanguage();
  }

  goToChatbot() {
    this.props.history.push(`${this.props.match.url}chatbot`);
  }
  goToArbitrationAgreement() {
    this.props.history.push(`${this.props.match.url}arbitrationAgreement`);
  }

  goToMainPage() {
    window.location.replace("https://www.hkarbsoc.org.hk");
  }

  componentWillMount() {
    let search = this.props.location.search || null;
    if (search) {
      const values = queryString.parse(search);
      const username = values.username || null;
      const password = values.password || null;
      this.props.onAuth(username, password, 'email', true);
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  render() {
    const { classes } = this.props;
    const onlineArbitrationClause = (
      <OnlineArbitrationClause
        windowWidth={this.state.windowWidth}
        copy={this.context.t("copy")}
        copied={this.context.t("copied")}
        text={this.context.t("onlineArbitrationClause")}
        mainText={this.context.t(
          "The following clause can be added by the parties to a contract who wish to have any future disputes referred to efficient arbitration in HKAS’s Online Arbitration Platform:"
        )}
        title={this.context.t("Arbitration Clause")}
      />
    );
    return (
      <div style={{ width: "" }}>
        {this.state.showOnlineArbitrationClauses && (
          <GeneralDialog
            component={onlineArbitrationClause}
            typeDialog={"showOnlineArbitrationClauses"}
            showDialog={this.showDialog}
          />
        )}
        {/* <LoginForm /> */}
        {/* <MainPanel/> */}
        {/* <Grid container spacing={3}>
          <Grid item xs={12}>
            <Grid
            container
            direction="row"
            justify="space-evenly"
            alignItems="flex-start"
            >
            {this.state.windowWidth > 1220 && <UsefulItemDialogList lang={this.props.lang} />}
            {this.state.windowWidth > 1220 && <ChatBox lang={this.props.lang} style={{width:'100%'}} /> }
            {this.state.windowWidth > 1220 && <LoginForm /> }
            {this.state.windowWidth <= 500 && <PrimaryAppBarMobile isAuthenticated={this.props.isAuthenticated} lang={this.props.lang} logoSize={'40%'} />}
            {this.state.windowWidth <= 500 && <ChatBoxMobile lang={this.props.lang} style={{marginTop:'20px', width:'100%'}} /> }
            { (this.state.windowWidth <= 1220 && this.state.windowWidth > 500) && <PrimaryAppBarMobile lang={this.props.lang} isAuthenticated={this.props.isAuthenticated} logoSize={'20%'} />}
            { (this.state.windowWidth <= 1220 && this.state.windowWidth > 500) && <ChatBoxMobile lang={this.props.lang} style={{width:'100%'}} /> }
            </Grid>
          </Grid>
        </Grid> */}

        <Grid container spacing={12}>
          <Grid item xs={12}>
            <Grid
              container
              direction="row"
              justify="space-evenly"
              alignItems="flex-start"
              style={{ padding: "10px" }}
            >
              <PrimaryAppBarMobile
                lang={this.props.lang}
                isAuthenticated={this.props.isAuthenticated}
                logoSize={"20%"}
              />
            </Grid>

            <Grid item xs={12}>
              {this.state.windowWidth > 700 && this.props.lang == "en" && (
                <img alt="" width={"100%"} src={desktopMainLogoEng} />
              )}
              {this.state.windowWidth > 700 && this.props.lang == "cn" && (
                <img alt="" width={"100%"} src={desktopMainLogo} />
              )}

              {this.state.windowWidth <= 700 && this.props.lang == "en" && (
                <img alt="" width={"100%"} src={mobileMainLogoEng} />
              )}
              {this.state.windowWidth <= 700 && this.props.lang == "cn" && (
                <img alt="" width={"100%"} src={mobileMainLogo} />
              )}
            </Grid>

            <Grid
              item
              xs={12}
              style={{
                textAlign: "center",

                padding: "2px",
                marginTop: "20px",
              }}
            >
              <p
                style={{ textTransform: "uppercase" }}
                className={classes.title}
              >
                {this.context.t("mainPageTitle2")}
              </p>
            </Grid>

            <Grid
              item
              xs={12}
              style={{ textAlign: "center", padding: "2px", marginTop: "0px" }}
            >
              <p
                style={{ textTransform: "uppercase" }}
                className={classes.title}
              >
                {this.context.t("mainPageTitle")}
              </p>
            </Grid>

            <Grid
              item
              xs={12}
              style={{
                textAlign: "justify",
                padding: "20px",
                marginBottom: "10px",
              }}
            >
              <p
                className={classes.mainText}
                style={{
                  textAlign: "justify",
                  textTransform: "inherit",
                  paddingLeft: this.state.windowWidth < 1200 ? "" : "280px",
                  paddingRight: this.state.windowWidth < 1200 ? "" : "280px",
                }}
              >
                {this.context.t("mainPageText")}
              </p>
            </Grid>

            {this.state.windowWidth <= 1200 && (
              <Grid
                style={{ padding: "13px" }}
                container
                className={classes.mainIcon}
              >
                <Grid container className={classes.mainIcon}>
                  <Grid item xs={4}>
                    <p className={classes.picFont}>
                      <img className="icon_theme" src={icon6} />
                      <br></br>
                      {this.context.t("icon6Text")}
                    </p>
                  </Grid>

                  <Grid item xs={4}>
                    <p className={classes.picFont}>
                      <img className="icon_theme" src={icon4} />
                      <br></br>
                      {this.context.t("icon4Text")}
                    </p>
                  </Grid>

                  <Grid item xs={4}>
                    <p className={classes.picFont}>
                      <img className="icon_theme" src={icon9} />
                      <br></br>
                      {this.context.t("icon9Text")}
                    </p>
                  </Grid>
                </Grid>
                <Grid container className={classes.mainIcon}>
                  <Grid item xs={4}>
                    <p className={classes.picFont}>
                      <img className="icon_theme" src={icon5} />
                      <br></br>
                      {this.context.t("icon5Text")}
                    </p>
                  </Grid>

                  <Grid item xs={4}>
                    <p className={classes.picFont}>
                      <img className="icon_theme" src={icon7} />
                      <br></br>
                      {this.context.t("icon7Text")}
                    </p>
                  </Grid>

                  <Grid item xs={4}>
                    <p className={classes.picFont}>
                      <img className="icon_theme" src={icon10} />
                      <br></br>
                      {this.context.t("icon10Text")}
                    </p>
                  </Grid>
                </Grid>
              </Grid>
            )}

            {this.state.windowWidth <= 1200 && (
              <Grid container className={classes.mainB}>
                <Grid item xs={12}>
                  <Button
                    style={{
                      float: "center",
                      minWidth: "220px",
                      marginBottom: "20px",
                    }}
                    variant="contained"
                    onClick={() => {
                      this.showDialog("typeDialog", true);
                    }}
                    className={classes.bInput}
                  >
                    {this.context.t("mainB1")}
                  </Button>
                  {this.state.typeDialog && (
                    <GeneralDialog
                      component={arbitrationProcedures}
                      typeDialog={"typeDialog"}
                      showDialog={this.showDialog}
                    />
                  )}
                </Grid>

                <Grid item xs={12}>
                  <Button
                    style={{ float: "center", minWidth: "220px" }}
                    variant="contained"
                    onClick={() => {
                      this.showDialog("calculator", true);
                    }}
                    className={classes.bInput}
                  >
                    {this.context.t("mainB2")}
                  </Button>
                  {this.state.calculator && (
                    <GeneralDialog
                      component={arbitratorFeeCalculator}
                      typeDialog={"calculator"}
                      showDialog={this.showDialog}
                    />
                  )}
                </Grid>
              </Grid>
            )}

            {this.state.windowWidth > 1200 && (
              <Grid
                container
                style={{
                  padding: "0px",
                  marginTop: "20px",
                  marginBottom: "20px",
                }}
                className={classes.mainIcon}
              >
                <Grid item xs={2}>
                  <p className={classes.picFont}>
                    <img className={classes.icons} src={icon6} />
                    <br></br>
                    {this.context.t("icon6Text")}
                  </p>
                </Grid>

                <Grid item xs={2}>
                  <p className={classes.picFont}>
                    <img className={classes.icons} src={icon4} />
                    <br></br>
                    {this.context.t("icon4Text")}
                  </p>
                </Grid>

                <Grid item xs={2}>
                  <p className={classes.picFont}>
                    <img className={classes.icons} src={icon9} />
                    <br></br>
                    {this.context.t("icon9Text")}
                  </p>
                </Grid>

                <Grid item xs={2}>
                  <p className={classes.picFont}>
                    <img className={classes.icons} src={icon5} />
                    <br></br>
                    {this.context.t("icon5Text")}
                  </p>
                </Grid>

                <Grid item xs={2}>
                  <p className={classes.picFont}>
                    <img className={classes.icons} src={icon7} />
                    <br></br>
                    {this.context.t("icon7Text")}
                  </p>
                </Grid>

                <Grid item xs={2}>
                  <p className={classes.picFont}>
                    <img className={classes.icons} src={icon10} />
                    <br></br>
                    {this.context.t("icon10Text")}
                  </p>
                </Grid>
              </Grid>
            )}
            {this.state.windowWidth > 1200 && (
              <Grid container className={classes.mainB}>
                <Grid item xs={6}>
                  <Button
                    style={{
                      float: "right",
                      marginRight: "30px",
                      minWidth: "190px",
                    }}
                    variant="contained"
                    onClick={() => {
                      this.showDialog("typeDialog", true);
                    }}
                    className={classes.bInput}
                  >
                    {this.context.t("mainB1")}
                  </Button>
                  {this.state.typeDialog && (
                    <GeneralDialog
                      component={arbitrationProcedures}
                      typeDialog={"typeDialog"}
                      showDialog={this.showDialog}
                    />
                  )}
                </Grid>

                <Grid item xs={6}>
                  <Button
                    style={{
                      float: "left",
                      marginLeft: "30px",
                      minWidth: "190px",
                    }}
                    variant="contained"
                    onClick={() => {
                      this.showDialog("calculator", true);
                    }}
                    className={classes.bInput}
                  >
                    {this.context.t("mainB2")}
                  </Button>
                  {this.state.calculator && (
                    <GeneralDialog
                      component={arbitratorFeeCalculator}
                      typeDialog={"calculator"}
                      showDialog={this.showDialog}
                    />
                  )}
                </Grid>
              </Grid>
            )}

            <Grid
              item
              xs={12}
              style={{ textAlign: "center", padding: "0px", marginTop: "60px" }}
            >
              <Grid item xs={12}>
                <p className={classes.title} style={{ marginBottom: "30px" }}>
                  {this.context.t("mainMidTitle")}
                </p>
              </Grid>
              <Grid item xs={12}>
                <p className={classes.lightTitle} style={{}}>
                  {this.context.t("mainMidTitle2")}
                </p>
              </Grid>
            </Grid>

            <Grid item xs={12} className={classes.mainC}>
              <Button
                style={{ minWidth: "250px", maxWidth: "250px" }}
                onClick={() => {
                  this.showDialog("showOnlineArbitrationClauses", true);
                }}
                variant="contained"
                className={classes.bInput}
              >
                {this.context.t("mainB3")}
              </Button>
            </Grid>
            <Grid item xs={12} className={classes.mainC}>
              <Button
                style={{ minWidth: "250px", maxWidth: "250px" }}
                onClick={() => {
                  this.goToArbitrationAgreement();
                }}
                variant="contained"
                className={classes.bInput}
              >
                {this.context.t("mainB4")}
              </Button>
            </Grid>
            <Grid item xs={12} className={classes.mainC}>
              <Button
                style={{ minWidth: "250px", maxWidth: "250px" }}
                onClick={() => {
                  this.goToChatbot();
                }}
                variant="contained"
                className={classes.bInput}
              >
                {this.context.t("mainB5")}
              </Button>
            </Grid>
            {/* {process.env.REACT_APP_MODE === "ts" && <Grid item xs={12} className={classes.mainC}>
              <Button
                style={{ minWidth: "250px", maxWidth: "250px" }}
                onClick={() => {
                  this.props.history.push('/documentUpload');
                }}
                variant="contained"
                className={classes.bInput}
              >
                {this.context.t("mainB6")}
              </Button>
            </Grid>} */}

           

            <Grid item xs={12} style={{ textAlign: "center" }}>
              <img
                style={{
                  width:
                    this.state.windowWidth > 500 && !this.props.isMobile
                      ? "90%"
                      : "90%",
                }}
                src={
                  this.props.lang == "en" ? mainTimelineEng : mainTimelineChi
                }
              ></img>
            </Grid>
            

            <Grid
              item
              xs={12}
              className={classes.mainC}
              style={{ marginTop: "50px", marginBottom: "50px" }}
            >
              <Button
                onClick={() => {
                  this.goToChatbot();
                }}
                variant="contained"
                className={classes.lastB}
              >
                {this.context.t("mainLastB")}
              </Button>
            </Grid>

            

            {this.state.windowWidth > 1200 && (
              <Grid item xs={12} className={classes.mainDd}>
                <img width="15%" src={logo}></img>
              </Grid>
            )}

            {this.state.windowWidth < 1200 && (
              <Grid item xs={12} className={classes.mainDd}>
                <img width="20%" src={logo}></img>
              </Grid>
            )}

             {/* <Grid
              item
              xs={12}
              style={{
                textAlign: "center",
                paddingLeft: this.state.windowWidth < 1200 ? "20px" : "280px",
                paddingRight: this.state.windowWidth < 1200 ? "20px" : "280px",
                marginTop: "40px",
                marginBottom: "40px",
              }}
            >
              <p
                style={{
                  fontSize: "21px",
                  color: "#000000",
                  textTransform: "uppercase",
                  // fontStyle: "italic",
                  textAlign: "justify",
                  fontWeight: "900",
                  lineHeight: "1.6",
                }}
              >
                {this.props.lang == "en"
                  ? <>
                      Hong Kong Arbitration Society believes{" "}
                      <span style={{ color: "#a31b2c" }}>
                        disputes can be resolved differently
                      </span>{" "}
                      and aims to promote the resolution of disputes through a
                      form of arbitration which is{" "}
                      <span style={{ color: "#a31b2c" }}>
                        more efficient, cost-effective and affordable
                      </span>
                      .
                    </>
                  : <>
                      香港仲裁協會相信{" "}
                      <span style={{ color: "#a31b2c" }}>
                        爭議可以以不同的方式解決
                      </span>
                      ，旨在透過一種{" "}
                      <span style={{ color: "#a31b2c" }}>
                        更有效率、更具成本效益且更實惠
                      </span>
                      的仲裁形式來推廣爭議解決。
                    </>}
              </p>
            </Grid> */}

            {/* {this.props.lang =='en' && <Grid item xs={12} style={{ textTransform: 'uppercase', textAlign:'justify', color:'black' }} className={classes.mainD}>
                {this.context.t("lastl1")}
              </Grid>}

              {this.props.lang =='en' && <Grid item xs={12} style={{ textTransform: 'uppercase', marginTop:'-25px', textAlign:'justify' }} className={classes.mainD}>
                <span className={classes.textRed}>
                  {this.context.t("lastl1r")}
                </span>
              </Grid>}

              {this.props.lang =='en' && <Grid item xs={12} style={{ textTransform: 'uppercase', marginTop:'-25px', textAlign:'justify', color:'black' }} className={classes.mainD}>
                  {this.context.t("lastl2")}
              </Grid>}

              {this.props.lang =='en' && <Grid item xs={12} style={{ textTransform: 'uppercase', marginTop:'-25px', textAlign:'justify', color:'black' }} className={classes.mainD}>
                  {this.context.t("lastl3")}
              </Grid>}

              {this.props.lang =='en' && <Grid item xs={12} style={{ textTransform: 'uppercase', marginTop:'-25px', textAlign:'justify', color:'black' }} className={classes.mainD}>
                  {this.context.t("lastl32")}
                  <span className={classes.textRed}>
                  {this.context.t("lastl3r")}
                </span>
              </Grid>}

              {this.props.lang =='en' && <Grid item xs={12} style={{ textTransform: 'uppercase', marginTop:'-25px', textAlign:'justify' }} className={classes.mainD}>
                  <span className={classes.textRed}>
                  {this.context.t("lastl3br")}
                </span>
              </Grid>} */}

            {/* {this.props.lang =='en' && <div style={{textAlign:'center', marginLeft:'280px', marginRight:'300px'}}>
              <p style={{
                fontSize: '21px',
                color: '#000000', 
                textTransform: 'uppercase',
                fontStyle: 'italic',
                textAlign:'justify',
                // color: "#99192D",
                fontWeight: "900",
              }}>
                {this.context.t("lastl1")}
                <span className={classes.textRed}>{this.context.t("lastl1r")}</span>
                {this.context.t("lastl2")}
                {this.context.t("lastl3")}
                {this.context.t("lastl32")}
                <span className={classes.textRed}>{this.context.t("lastl3r")}{this.context.t("lastl3br")}</span>
              </p>
            </div>} */}

            {this.props.lang == "en" && (
              <div
                className=""
                style={{
                  textAlign: "center"
                }}
              >
                <img
                  alt=""
                  className="img_theme"
                  src={sloganEng}
                ></img>
              </div>
            )}

            {this.props.lang == "cn" && (
              <div
                style={{
                  textAlign: "center",
                  paddingLeft: "10px",
                  paddingRight: "10px",
                }}
              >
                <img className="img_theme_chi" src={sloganChi}></img>
              </div>
            )}

            {/* {this.props.lang =='cn' && <Grid item xs={12} className={classes.mainD}>
              {this.context.t("lastl1")}
              <span className={classes.textRed}>
                {this.context.t("lastl1r")}
              </span>
            </Grid>}

            {this.props.lang =='cn' && <Grid item xs={12} className={classes.mainD}>
              {this.context.t("lastl2")}
              <span className={classes.textRed}>
                {this.context.t("lastl2")}
              </span>
            </Grid>}

            {this.props.lang =='cn' && <Grid item xs={12} className={classes.mainD}>
              {this.context.t("lastl3")}
              <span className={classes.textRed}>
                {this.context.t("lastl2r")}
              </span>
              {this.context.t("lastl3b")}
            </Grid>} */}

            {/* {this.props.lang =='cn' && <div style={{textAlign:'center', paddingLeft: '500px', paddingRight:'500px'}}>
              <p style={{
                fontSize: '21px',
                color: '#000000', 
                textTransform: 'uppercase',
                fontStyle: 'italic',
                textAlign:'center',
                fontWeight: "900",
              }}>
                {this.context.t("lastl1")} <span className={classes.textRed}>{this.context.t("lastl1r")}</span>
                {this.context.t("lastl2")}
                {this.context.t("lastl3")}
                <span className={classes.textRed}>{this.context.t("lastl3r")}{this.context.t("lastl2r")}</span>
                {this.context.t("lastl3b")}
              </p>
            </div>} */}

            <Grid item xs={12} className={classes.mainB}>
              <Button
                onClick={() => {
                  this.goToMainPage();
                }}
                variant="contained"
                style={{
                  textTransform: "uppercase",
                  marginBottom: "60px",
                  marginTop: "20px",
                }}
                className={classes.bInput}
              >
                {this.context.t("lastB")}
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <Footer />
      </div>
    );
  }
}

LandingPage.contextTypes = {
  t: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.token !== null,
    lang: state.i18nState.lang,
  };
};

const mapSizesToProps = (sizes) => ({
  isMobile: withSizes.isMobile(sizes),
  isTablet: withSizes.isTablet(sizes),
  isDesktop: withSizes.isDesktop(sizes),
  isGtMobile: withSizes.isGtMobile(sizes),
  isGtTablet: withSizes.isGtTablet(sizes),
  isStTablet: withSizes.isStTablet(sizes),
  isStDesktop: withSizes.isStDesktop(sizes),
  isTabletAndGreater: withSizes.isTabletAndGreater(sizes),
  isTabletAndSmaller: withSizes.isTabletAndSmaller(sizes),
});

const mapDispatchToProps = (dispatch) => {
  return {
    onAuth: (username, password, method, autologin) => dispatch(actions.auth(username, password, method, autologin)),
    onTryAutoSignIn: () => dispatch(actions.checkAuthState()),
  };
};

export default withStyles(styles)(
  withRouter(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(withSizes(mapSizesToProps)(LandingPage))
  )
);
